<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";

import addedit from "./addedit";
import { required } from "vuelidate/lib/validators";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";


export default {
  mixins: [Api, Sabit],
  page: {
    title: "Takvim",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    FullCalendar,
    Layout,
    PageHeader,
    addedit,
  },
  data() {
    return {
      title: "Takvim",
      items: [
        {
          text: "Anasayfa",
        },
        {
          text: "Sistem Yönetimi",
          href: "/",
        },
        {
          text: "Takvim",
          active: true,
        },
      ],
      DataUpdate: "",
      AddEdit: "",
      calendarOptions: {
        buttonText: {
          today: 'Bugün',
          month: 'Ay',
          week: 'Hafta',
          day: 'Gün',
          list: 'Liste'
        },
        locale: 'tr',
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        initialView: "dayGridMonth",
        themeSystem: "bootstrap",
        initialEvents: null,
        editable: true,
        droppable: true,
        eventResizableFromStart: true,
        dateClick: this.dateClicked,
        eventClick: this.editEvent,
        eventsSet: this.handleEvents,
        weekends: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
      },
      currentEvents: [],
      showModal: false,
      eventModal: false,
      submitted: false,
      submit: false,
      newEventData: {},
      edit: {},
      deleteId: {},
      event: {
        title: "",
        category: "",
      },
      editevent: {
        editTitle: "",
        editcategory: "",
      },
      BaslangicTarih: null
    };
  },
  validations: {
    event: {
      title: { required },
      category: { required },
    },
  },

  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "otakvim",
        FullData: true,
        Filter: "&Userid=" + this.TokenUserId,
      }).then((res) => {
        var Data = res.Data

        this.ActionsFilterGet({
          Service: "oresmitatil",
          FullData: true,
          Filter: "&Desc=",
        }).then((res2) => {
          var Data2 = res2.Data
          this.calendarOptions.initialEvents = this.transformData(Data).concat(this.transformData2(Data2));
        });
      });
    },
    transformData(data) {
      return data.map(item => ({
        hamhali: item,
        id: item.Id,
        title: item.Baslik,
        className: item.Kategori,
        start: new Date(item.Baslangic).getTime() + (3 * 60 * 60 * 1000),
        end: new Date(new Date(item.Bitis).getTime() + (3 * 60 * 60 * 1000)).toISOString(),
      }));
    },
    transformData2(data) {
      return data.map(item => ({
        id: item.Id,
        title: item.Adi,
        className: "bg-danger",
        start: new Date(item.Gun).getTime() + (3 * 60 * 60 * 1000),
        end: new Date(new Date(item.Gun).getTime() + (3 * 60 * 60 * 1000)).toISOString(),
      }));
    },
    dateClicked(info) {
      this.BaslangicTarih = info.date
      this.newEventData = info;
      this.DataUpdate = this.event
      this.AddEdit = 'Add'
    },

    editEvent(info) {
      this.edit = info.event;
      this.editevent.editTitle = this.edit.title;
      this.editevent.editcategory = this.edit.classNames[0];
      this.eventModal = true;
      this.DataUpdate = info.event.extendedProps.hamhali
      this.AddEdit = 'Edit'
    },




  },
  created() {

  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="app-calendar" v-if="calendarOptions.initialEvents">
              <FullCalendar ref="fullCalendar" :options="calendarOptions"></FullCalendar>
            </div>
          </div>
        </div>
      </div>
    </div>


    <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get()"
      @ModalOpen="DataUpdate = null, AddEdit = null, Get()" :BaslangicTarih="BaslangicTarih" />
  </Layout>



</template>
